// Restrained geometric marks inspired by the Amanah symbol
// (a navy triangular "A" with green vertical bars). Vector only — the
// authoritative supplied logos are never redrawn or recoloured here.

export function TriangleMark({
  className = "",
  strokeColor = "#0A2450",
  barLight = "#1E7A46",
  barDark = "#0A5C39",
}) {
  return (
    <svg
      viewBox="0 0 320 300"
      className={className}
      fill="none"
      role="presentation"
      aria-hidden="true"
    >
      <path
        d="M160 18 L300 282 L20 282 Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinejoin="round"
        opacity="0.85"
      />
      <rect x="118" y="150" width="26" height="112" fill={barLight} />
      <rect x="152" y="116" width="26" height="146" fill={barDark} />
      <path
        d="M96 262 C150 210 190 150 232 96"
        stroke={barLight}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M258 74 L264 56 L270 74 L288 80 L270 86 L264 104 L258 86 L240 80 Z"
        fill={barLight}
      />
    </svg>
  );
}

// A tiny diamond bullet used in lists and eyebrow rows.
export function Diamond({ className = "" }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block h-2 w-2 rotate-45 bg-brand-green ${className}`}
    />
  );
}

// A section eyebrow: diamond + uppercase tracked label in brand green.
export function Eyebrow({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-brand-green ${className}`}
    >
      <Diamond />
      {children}
    </span>
  );
}
